import Calendar from './Calendar';
import { set as setLocalizer } from './localizer';
import momentLocalizer from './localizers/moment';
import globalizeLocalizer from './localizers/globalize';
import viewLabel from './utils/viewLabel';
import move from './utils/move';
import { views } from './utils/constants';

Calendar.setLocalizer = setLocalizer;
Calendar.globalizeLocalizer = globalizeLocalizer;
Calendar.momentLocalizer = momentLocalizer;
Calendar.label = viewLabel;
Calendar.views = views;
Calendar.move = move;

export default Calendar;
